<header class="text-gray-400 body-font">
  <div
    class="container mx-auto flex flex-wrap p-5 gap-x-5 gap-y-2 items-center"
  >
    <a
      routerLink="/"
      class="flex title-font font-medium items-center text-white mb-0"
    >
      <img src="assets/logo-darkmode.svg" class="h-6" />
      <span
        class="bg-white text-gray-900 px-2 rounded-lg ml-2 -mr-2 text-xs sm:text-base"
        >Early Access</span
      >
    </a>
    <nav
      class="ml-auto flex flex-wrap items-center text-base justify-center gap-x-2"
    >
      <a href="https://help.clouddeck.app" target="_blank">Help</a>
    </nav>

    <div
      class="flex justify-center"
      *ngIf="auth.userProfile$ | async as profile"
      (clickOutside)="onClickOutside()"
    >
      <div class="relative">
        <button
          class="block h-12 w-12 rounded-full overflow-hidden focus:outline-none"
          (click)="collapsed = !collapsed"
        >
          <div
            class="rounded-full h-12 w-12 flex items-center justify-center bg-gray-800 hover:bg-gray-700"
          >
            <i-lucide name="user" class="text-white"></i-lucide>
          </div>
        </button>
        <div
          *ngIf="!collapsed"
          class="absolute right-0 w-48 p-2 mt-2 bg-gray-800 rounded-lg"
          (click)="collapsed = true"
        >
          <a
            routerLink="account"
            class="transition-colors duration-200 block px-4 py-2 text-normal text-gray-200 rounded-lg hover:bg-gray-700 hover:text-white hover:no-underline"
            >Account</a
          >
          <a
            (click)="logout()"
            class="transition-colors duration-200 block px-4 py-2 text-normal text-gray-200 rounded-lg hover:bg-gray-700 hover:text-white cursor-pointer hover:no-underline"
          >
            Logout
          </a>
        </div>
      </div>
    </div>
  </div>
</header>
